import numeral from 'numeral'
export default {
  methods: {
    convertNumber: function (number) {
      let num = Math.round(+number * 100) / 100
      return String(num.toFixed(2)).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    },
    numeralConvertNumber: function (number) {
      return numeral(number).format('0,0.00')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/convertNumber.js